import VoipLayout from '../components/layouts/VoipLayout.vue';
import VoipIndexPage from '../pages/VoipIndexPage.vue';

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
  {
    // This is the parent route for your package.
    // It uses the layout component.
    path: '/voip',
    name: 'voip.root',
    component: VoipLayout,
    meta: {
      // e.g., requiresAuth: true
      // requiresAuth: true,
      // title: 'voip.nav.title',
      layout: 'Authenticated',
    },
    // All other package routes are children of this layout
    children: [
      {
        // Child path is empty, so it renders at /voip
        path: '',
        name: 'VoipIndexPage',
        component: VoipIndexPage,
      },
      // --- Example of other child routes ---
      // {
      //   path: 'create', // Renders at /voip/create
      //   name: 'voip.create',
      //   component: () => import('../components/Create.vue'),
      // },
    ]
  }
];
